// Toggle.js
import React from 'react';
import useSound from 'use-sound';
import { func, string } from 'prop-types';

import moon from '../../assets/icons/light/moon.svg';
import sun from '../../assets/icons/dark/sun.svg';
import clickSfx from '../../assets/audio/lightswitch-trimmed.mp3';
import styles from './Toggle.module.scss';

function Toggle({ theme, toggleTheme }) {
  const [play] = useSound(clickSfx);

  return (
    <button
      className={styles.button}
      type="button"
      onClick={() => {
        toggleTheme();
        play();
      }}
    >
      <img src={theme === 'light' ? moon : sun} alt="theme toggle button" />
    </button>
  );
}

Toggle.propTypes = {
  theme: string.isRequired,
  toggleTheme: func.isRequired,
};

export default Toggle;
